/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseImageFragment = gql`
  fragment BaseImageFragment on Image {
    __typename
    alignment
    altText
    description
    desktopAsset {
      url
      title
      description
      contentType
    }
    fit
    focus
    format
    height
    mobileAsset {
      url
      title
      description
      contentType
    }
    openInNewTab
    quality
    sys {
      id
    }
    tabletAsset {
      url
      title
      description
      contentType
    }
    title
    url
    width
  }
`;
